<div id="recover-wrapper" [style.background]="'url(../../../assets/organisation/images/background.png)'">
  <div id="recover-container">
    <div class="header">
      <div class="logo">
        <img src="../../../assets/organisation/images/logo-auth.svg" [alt]="'IMAGE_ALT.LOGO' | translate" />
      </div>
    </div>
    <div class="inner">
      <form>
        <div class="field field-prefix">
          <label>{{ "RESETPASSWORD.PASSWORD" | translate }}</label>
          <app-prefix-wac [counter]="false" (controlchanged)="password = $event" />
        </div>

        <div class="field field-prefix">
          <label>{{ "RESETPASSWORD.PASSWORD_CONFIRM" | translate }}</label>
          <app-prefix-wac [counter]="false" (controlchanged)="passwordConfirm = $event" />
        </div>

        <button type="button" (click)="recover()">
          {{ "RESETPASSWORD.SUBMIT" | translate }}
        </button>

        @if (isLoading) {
          <div id="loading-container">
            <mat-progress-spinner [color]="'primary'" [diameter]="48" [mode]="'indeterminate'" />
          </div>
        }
      </form>
    </div>
  </div>
</div>
